export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ02.1d64b2b1.mp3";